// AD-2741 (Maria, 20 October 2026): the four Auto Reminder boxes stay four to a row wherever each box can show 1000
// and its name, and go two to a row below that (under 720 pixels). From 1200 pixels they sit in the left half of the page.
export const REMINDER_SPAN = {xs: 'span 2', lg: 'span 3'};
export const FOUR_REMINDERS_TO_A_ROW = {'@media (min-width: 720px) and (max-width: 1199.95px)': {gridColumn: 'span 1'}};
